import { handlePostAction } from "../../../utils/event-api-invoke";

let _isError = false;

const getPostPayload = (data) => {
  try {
    let _postPayload =
    {
      AuditId: data.AuditId,
      ShortDesc: data.ShortDesc,
      Location: data.Location,
      LocationKey: data.LocationKey,
      CurrentState: data.CurrentState,
      PreviousState: data.PreviousState,
      Action: data.Action,
      UserEmail: data.UserEmail
    };
    return _postPayload;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const approveChange = async (data) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  try {
    let _postRequest = {
      countryCode: data.CountryCode,
      businessCode: data.BusinessCode,
      auditInfo: [],
    };
    let _postPayload = getPostPayload(data);

    _postRequest.auditInfo.push({
      ..._postPayload,
      Status: "APPROVED",
      CountryCode: data.countryCode,
      BusinessCode: data.businessCode,
    });

    let res = await handlePostAction(_postRequest, "auditinfo");
    if (res && res.status && res.status === 200) {
      status.responseStatus = res.status;
    }
  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

const rejectChange = async (data) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  try {
    let _postRequest = {
      countryCode: data.CountryCode,
      businessCode: data.BusinessCode,
      auditInfo: [],
    };
    let _postPayload = getPostPayload(data);

    _postRequest.auditInfo.push({
      ..._postPayload,
      Status: "REJECTED",
      CountryCode: data.countryCode,
      BusinessCode: data.businessCode,
    });

    let res = await handlePostAction(_postRequest, "auditinfo");
    if (res && res.status && res.status === 200) {
      status.responseStatus = res.status;
    }
  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { approveChange, rejectChange };
